import {
    Alert,
    ExclamationTriangleIcon,
    Flex,
    Loader,
} from "@fluentui/react-northstar";
import React from "react";
import StepTitle from "../../../../components/StepsTitle/StepTitle";
import RessourcesCheckable from "../../../../components/Accordions/RessourcesCheckable/RessourcesCheckable";
import FooterActionButtons from "../../components/footer/FooterActionButtons";
import useLogicStepEquipments from "../../hooks/useLogicStepEquipments";

const StepEquipments = () => {
    const { query, navigation } = useLogicStepEquipments();

    if (query.isLoading) {
        return <Loader label={"Chargement ..."} />;
    }

    if (!query.data) {
        return (
            <Alert
                content="Une erreur est survenue ! Veuillez réessayer plus tard !"
                icon={<ExclamationTriangleIcon />}
                danger
            />
        );
    }

    return (
        <Flex fill column space="between" gap="gap.large">
            {/* title */}
            <Flex column gap="gap.large">
                <StepTitle
                    title="Matériel et accès"
                    step_number={3}
                    is_required={false}
                />
            </Flex>
            {/* resources */}
            <Flex column>
                <RessourcesCheckable resources={query.formated_data} readOnly />
            </Flex>
            {/* footer */}
            <FooterActionButtons
                enableButtonBackStep={true}
                enableButtonNextStep={true}
                onClickNextStep={navigation.buttonNextStep}
                onClickBackStep={navigation.buttonBackStep}
            />
        </Flex>
    );
};

export default StepEquipments;
